export default "__VITE_ASSET__CaPNDD9Q__"